import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeSwitcher.css';

interface ThemeSwitcherProps {
  sidebarOpen?: boolean;
}

const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ sidebarOpen = true }) => {
  const { mode, toggleMode } = useTheme();

  return (
    <div className="theme-switcher">
      <button
        className="theme-toggle-btn"
        onClick={toggleMode}
        title={mode === 'light' ? 'Passer en mode sombre' : 'Passer en mode clair'}
      >
        <span className="theme-icon">{mode === 'light' ? '☀️' : '🌙'}</span>
        {sidebarOpen && <span className="theme-text">{mode === 'light' ? 'Clair' : 'Sombre'}</span>}
      </button>
    </div>
  );
};

export default ThemeSwitcher;
